module.exports = __webpack_public_path__ + "static/media/RPR 26T Drive.b29080b3.jpg";